var _defineProperty = require("/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var pageResults = require('graph-results-pager');

var _require = require('graphql-request'),
    request = _require.request,
    gql = _require.gql;

var _require2 = require('./sushi'),
    sushiPriceUSD = _require2.priceUSD;

var _require3 = require('./exchange'),
    tokenInfo = _require3.token;

var _require4 = require('./exchange'),
    ethPriceUSD = _require4.ethPrice;

var _require5 = require('./masterchef'),
    masterChefInfo = _require5.info;

var _require6 = require('./masterchef'),
    chefPool = _require6.pool;

var _require7 = require('./masterchef'),
    chefPools = _require7.pools; // accessed by chainId


var ENDPOINTS = {
  1: 'https://api.thegraph.com/subgraphs/name/sushiswap/bentobox',
  250: 'https://api.thegraph.com/subgraphs/name/sushiswap/fantom-bentobox',
  56: 'https://api.thegraph.com/subgraphs/name/sushiswap/bsc-bentobox',
  137: 'https://api.thegraph.com/subgraphs/name/sushiswap/matic-bentobox',
  100: 'https://api.thegraph.com/subgraphs/name/sushiswap/xdai-bentobox'
};
var MASTER_CONTRACT = '0x2cba6ab6574646badc84f0544d05059e57a5dc42';
module.exports = {
  clones: function clones() {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, _ref$masterAddress, masterAddress, _ref$chainId, chainId;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {}, _ref$masterAddress = _ref.masterAddress, masterAddress = _ref$masterAddress === void 0 ? undefined : _ref$masterAddress, _ref$chainId = _ref.chainId, chainId = _ref$chainId === void 0 ? undefined : _ref$chainId;

              if (masterAddress) {
                _context.next = 3;
                break;
              }

              throw new Error("sushi-data: Master Address undefined");

            case 3:
              if (chainId) {
                _context.next = 5;
                break;
              }

              throw new Error("sushi-data: Chain Id undefined");

            case 5:
              return _context.abrupt("return", pageResults({
                api: ENDPOINTS[chainId],
                query: {
                  entity: 'clones',
                  selection: {
                    where: {
                      masterContract: "\\\"".concat(masterAddress.toLowerCase(), "\\\"")
                    }
                  },
                  properties: _clones.properties
                }
              }).then(function (results) {
                return _clones.callback(results);
              }).catch(function (err) {
                return console.log(err);
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  kashiStakedInfo: function kashiStakedInfo() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var results, result, masterChef, pools, onsen_pools, filtered_results;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return pageResults({
                api: ENDPOINTS[1],
                query: {
                  entity: 'kashiPairs',
                  properties: _kashiStakedInfo.properties
                }
              });

            case 2:
              results = _context2.sent;
              result = {};
              _context2.next = 6;
              return sushiPriceUSD();

            case 6:
              result.sushiUSD = _context2.sent;
              _context2.next = 9;
              return ethPriceUSD();

            case 9:
              result.ethUSD = _context2.sent;
              _context2.next = 12;
              return masterChefInfo();

            case 12:
              masterChef = _context2.sent;
              result.totalAP = masterChef.totalAllocPoint;
              result.sushiPerBlock = masterChef.sushiPerBlock;
              _context2.next = 17;
              return chefPools();

            case 17:
              pools = _context2.sent;
              onsen_pools = pools.map(function (pool) {
                return pool.pair;
              });
              filtered_results = results.filter(function (pair) {
                return onsen_pools.includes(pair.id);
              });
              result.kashiPairs = filtered_results;
              return _context2.abrupt("return", _kashiStakedInfo.callback(result));

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};
var _clones = {
  properties: ['id', 'data'],
  callback: function callback(results) {
    return results.map(function (_ref2) {
      var id = _ref2.id,
          data = _ref2.data,
          block = _ref2.block,
          timestamp = _ref2.timestamp;
      return {
        address: id,
        data: data
      };
    });
  }
};
var _kashiStakedInfo = {
  properties: ['id', 'name', 'symbol', 'asset { id, symbol, decimals }', 'collateral { id, symbol, decimals }', 'totalAssetBase', 'totalAssetElastic'],
  callback: function callback(results) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Promise.all(results.kashiPairs.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(result) {
                  var _ref4;

                  var asset, assetPool, stakedAmt, balanceUSD, rewardPerBlock, roiPerBlock, roiPerYear;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return tokenInfo({
                            token_address: result.asset.id
                          });

                        case 2:
                          asset = _context3.sent;
                          _context3.next = 5;
                          return chefPool({
                            pool_address: result.id
                          });

                        case 5:
                          assetPool = _context3.sent;

                          if (!(assetPool === undefined)) {
                            _context3.next = 8;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 8:
                          stakedAmt = assetPool.slpBalance * 1e18;
                          balanceUSD = stakedAmt * asset.derivedETH * results.ethUSD / Math.pow(10, result.asset.decimals);
                          rewardPerBlock = 1 / results.totalAP * results.sushiPerBlock;
                          roiPerBlock = rewardPerBlock * results.sushiUSD / balanceUSD;
                          roiPerYear = roiPerBlock * 6500 * 365;
                          return _context3.abrupt("return", (_ref4 = {
                            id: result.id,
                            name: result.name,
                            symbol: result.symbol,
                            asset: result.asset.id,
                            assetSymbol: result.asset.symbol,
                            assetDecimals: Number(result.asset.decimals),
                            collateral: result.collateral.id,
                            collateralSymbol: result.collateral.symbol,
                            collateralDecimals: Number(result.collateral.decimals),
                            totalAssetBase: Number(result.totalAssetBase),
                            totalAssetElastic: Number(result.totalAssetElastic),
                            totalAssetStaked: Number(stakedAmt)
                          }, _defineProperty(_ref4, "assetDecimals", Number(result.asset.decimals)), _defineProperty(_ref4, "balanceUSD", balanceUSD), _defineProperty(_ref4, "rewardPerBlock", rewardPerBlock), _defineProperty(_ref4, "roiPerBlock", roiPerBlock), _defineProperty(_ref4, "roiPerYear", roiPerYear), _ref4));

                        case 14:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};